export default __webpack_public_path__ + "static/power_media_2-d427da65d87b7c0f1414cb137e788ca9.webp";